import React, { Component } from 'react';
import {getConfig} from '../../config.js';
import {darkMode, infiniteTitle} from '../../Utils.js';

import Projectcard from '../../components/Projectcard/Projectcard.js';
import TitleLoop from '../../components/TitleLoop/TitleLoop.js'

import './Work.scss';

export class Work extends Component {

  constructor(props) {
    super(props);

    let darkMode = false;

    this.state = { data: {}, darkMode: darkMode};
    this.renderProjects = this.renderProjects.bind(this);
    this.populatePageAfterFetch = this.populatePageAfterFetch.bind(this);
  }

  componentDidMount() {
    document.getElementsByClassName('site__scrollable')[0].scrollTop = 0;
    darkMode(this.state.darkMode);
  }

  renderProjects() {
    if (this.props.projects) {
      const projectsArray = Object.values(this.props.projects)
      return Object.values(projectsArray).map((project, index) => this.populatePageAfterFetch(project, index));
    }
  }

  populatePageAfterFetch(project, index) {
    const zeroPad = (num, places) => String(num).padStart(places, '0');

    if (this.props.projects) {
      let url = this.props.url + project.slug;
      let featuredimageanimated = (project.acf.featured_animated_image) ? project.acf.featured_animated_image.url : false;
      return (
        <div className="grid__item" key={index}>
          <Projectcard index={zeroPad(index + 1, 2)} size="projectcard--medium" title={project.title.rendered} featuredimageanimated={featuredimageanimated} featuredimage={project.featured_image_url} url={url} />
        </div>
      )
    }
  }

  render() {


    let title = this.props.content.title;
    let content = this.props.content.content;

    return (
      <main>
        <section className="module module--work module--ontop">
          <div className="module__inner">
            <header className="module__header">
              <div className="module__header__inner">
                <h1 className="module__header__title">
                  <TitleLoop title={title} />
                </h1>
              </div>
            </header>

            <div className="module__body" data-scroll data-scroll-class="inview">
              <div className="module__body__inner">
                <div className="module__body__grid">
                  <div className="grid">
                    {this.renderProjects()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    )
  }
}
